import { createSelector } from 'reselect'
import type { ExtendedJobFile } from '../files/reducer'
import type { FileWithGrouping } from '../files/selectors'
import { getJobFilesWithGrouping } from '../files/selectors'
import type { StateWithSelectedFiles } from './reducer'

export const getSelectedFileIDs = (state: StateWithSelectedFiles) =>
    state.selectedFiles.files

export const getSelectedFilesForJob = createSelector(
    getSelectedFileIDs,
    getJobFilesWithGrouping,
    (fileIDs, jobFiles: FileWithGrouping[]): FileWithGrouping[] => {
        return jobFiles.filter((jobFile) => fileIDs.includes(jobFile.fileID))
    },
)

export const getSelectedFileIDsforJob = createSelector(
    getSelectedFilesForJob,
    (files): FileID[] => files.map((f) => f.fileID),
)

const getFileSize = (file: FileWithGrouping<ExtendedJobFile>) => {
    let val = file.size

    if (file.livePhotoFile) {
        val += file.livePhotoFile.size
    }
    if (file.burstFiles) {
        val += file.burstFiles.reduce(
            (accBurst, currBurst) => accBurst + currBurst.size,
            0,
        )
    }
    return val
}

export const getSelectedFileSizeforJob = createSelector(
    getSelectedFilesForJob,
    (files): number => files.reduce((acc, f) => acc + getFileSize(f), 0),
)

export const makeIsFileSelected = (fileID: FileID) =>
    createSelector(getSelectedFileIDs, (files) => files.includes(fileID))

export const getSelectionAction = (state: StateWithSelectedFiles) =>
    state.selectedFiles.selectionAction
